import script from "./ComparisonResultsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ComparisonResultsModal.vue?vue&type=script&setup=true&lang=js"

import "./ComparisonResultsModal.vue?vue&type=style&index=0&id=b1615e1e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1615e1e"]])

export default __exports__